import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  HostListener,
  ViewChild
} from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Platform, ModalController, IonRouterOutlet } from '@ionic/angular';

@Component({
  selector: 'app-category-selection',
  templateUrl: './category-selection.component.html',
  styleUrls: ['./category-selection.component.scss'],
})
export class CategorySelectionComponent implements OnInit {

  @Input() category;
  @Input() product;
  @ViewChild(IonRouterOutlet, { static : true }) routerOutlet!: IonRouterOutlet;
  search:any;
  category_list:any = [];
  
  // @Output() save = new EventEmitter();
  constructor(public modalCtrl:ModalController,public db:DataService,private platform: Platform) { 

    // this.platform.backButton.subscribeWithPriority(-1, () => {
    //   console.log('back');
    //   if (!this.routerOutlet.canGoBack()) {
    //    console.log('back');
    //     this.modalCtrl.dismiss();
    //   }
    // });

    
  }

  ngOnInit() {

    // console.log(this.category);
    // this.category_list = this.category;

    this.get_values();

    setTimeout(() => {
      this.check_selected_();
    }, 700);

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }


  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }

  get_values(){
    let array = this.category;

    this.get_filters(array,'');

    array.map(res=> { 
      if(res.child && res.child != 0){
       
       this.get_filters(res.child,'');

        res.child.map(r=>{
          if(r.child && r.child != 0){
            this.get_filters(r.child,'');
          }
        })
          
      }
    })
  }
  


  check_selected_(){
    if(this.product && this.product.product_categories && this.product.product_categories.length != 0){
      this.product.product_categories.map(res=>{
        this.category_list.map(par =>{
           if(par.name == res.category){
             par.selected = 1
           }
          //  else{
          //   par.selected = 0
          //  }

           if(res.child && res.child.length != 0){
              res.child.map(sub=>{

                if(sub.name == res.name){
                  sub.selected = 1;
                  sub.child_value = true;
                }

                if(sub.child && sub.child.length != 0){
                  sub.child.map(sub_child=>{
                    if(sub_child.name == res.name){
                      sub_child.selected = 1;
                      sub_child.child_value = true;
                    }
                  })
               }

              })
           }
        })
      })
      
    }else{
      this.category_list.map(par =>{
         par.selected = 0
      })
    }
 
  }

  check_selected(data){
    let d = 0
    if(this.product.product_categories != undefined)
      this.product.product_categories.map(res =>{
        res.category == data.name ?  d = 1 : null
      })



    return d
  }

  save_value(){
    this.category_list = [];
    this.get_values();
    // this.search = '';
    let d:any = [];
    let v = this.category_list;
    v.map(res =>{
      if(res.selected){
        let y = {
          category : res.name,
          doctype : "Product Category Mapping",
          parent : this.product.name,
          parentfield : "product_categories",
          parenttype : "Product",
          category_name : res.category_name
        }
        d.push(y)
        // d = [...d,...res]
      }
      // res.selected = this.check_selected(res)
    })
    // console.log(d)
    this.modalCtrl.dismiss(d)
  }

  check_parent(obj){
    obj.selected = obj.selected ? false : true;
    // console.log(obj);
  }

  check_parent1(eve,obj){
    // console.log(obj);
    this.check_parent(obj);
  }

  check_sub_child(eve,obj){
    // obj.selected = obj.selected ? 0 : 1;
    obj.child_value = obj.child_value ? false :true;
    // console.log(obj);
    if(eve.detail.checked){
      this.category_list.push(obj)
    }else{
      this.category_list = this.category_list.filter(res=> res.name != obj.name);
    }
  }

  check_sub_child1(eve,obj){
    // obj.selected = obj.selected ? 0 : 1;
    obj.child_value = obj.child_value ? false :true;
    // console.log(obj);
    if(eve.detail.checked){
      this.category_list.push(obj)
    }else{
      this.category_list = this.category_list.filter(res=> res.name != obj.name);
    }
  }

  getItems(val) {
    if(val && val.target && val.target.value && val.target.value != ''){
      let value = val.target.value;
      this.category_list = [];
      
      this.get_values();

      this.category_list = this.category_list.filter(res=> {
        return res.category_name.toLowerCase().includes(value.toLowerCase())
      })
    }else{
      this.category_list = [];
      this.get_values();
    }
  }

  get_filters(array,value){
    // let filter_values = array.filter(res=> {
    //   return res.category_name.toLowerCase().includes(value.toLowerCase())
    // })
    // return filter_values;
    this.category_list = [...this.category_list,...array];
  }

}
